import React, { FC, useEffect, useState } from "react";
import { withLayout } from "@pages/dashboard/DashboardPage";
import HeaderDashboardLayout from "@layouts/headerDashboardLayout/HeaderDashboardLayout";
import st from './uralchem.module.scss';
import { Color, Width } from "@baseTypes/baseType";
import { Button2, Type as T } from "@infobis/ui-styles-utils";
import cn from "classnames";
import Form from "@pages/partners/items/uralchem/form/Form";
import { ApplicationDataState } from "@pages/partners/items/uralchem/form/types";
import { isNil, pickBy } from "lodash";
import Activities from "@pages/partners/items/uralchem/sections/activities/Activities";
import Equipment from "@pages/partners/items/uralchem/sections/equipment/Equipment";
import Contacts from "@pages/partners/items/uralchem/sections/contacts/Contacts";
import Staff from "@pages/partners/items/uralchem/sections/staff/Staff";
import Logo from "@pages/partners/items/uralchem/components/logo/Logo";
import Advantages from "@pages/partners/items/uralchem/sections/advantages/Advantages";
import Service from "@pages/partners/items/uralchem/sections/service/Service";

interface UralchemProps {}

const Uralchem: FC<UralchemProps> = () => {

    const [isVisible, setVisible] = useState(false);

    const [testType, setTestType] = useState<ApplicationDataState['testType']>();

    useEffect(() => {
        if (testType) {
            setVisible(true);
        }
    }, [testType]);

    useEffect(() => {
        if (!isVisible) {
            setTestType(undefined);
        }
    }, [isVisible]);

    const additionalInitial = pickBy({testType}, (value) => !isNil(value));

    const orderBtn = (
        <Button2.Primary onClick={() => {
            setVisible(!isVisible)
        }} size={T.Size.LARGE}>
            {'Оформить заявку'}
        </Button2.Primary>
    );

    return (
        <HeaderDashboardLayout
            contentContainerWidth={Width.Full}
            cropVisible={false}
            className={st['uralchem-wrp']}
            color={Color.AbsolutelyWhite}
            headerClassName={st['wrapper']}
            scrollWithBackground
        >
            <header className={st['header']}>
                <Logo/>
                {orderBtn}
            </header>
            <main className={cn(st['uralchem__content'], st['content'])}>
                <Advantages className={st['content__section']}/>
                <Activities className={st['content__section']}/>
                <Service className={st['content__section']} setTestType={setTestType}/>
                <Equipment className={st['content__section']}/>
                <Staff className={st['content__section']}/>
            </main>
            <footer className={st['footer']}>
                <Contacts orderBtn={orderBtn}/>
            </footer>
            {isVisible && <Form additionalInitial={additionalInitial} hideWindow={() => setVisible(false)}/>}
        </HeaderDashboardLayout>
    );
};

export default withLayout(Uralchem);